import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  Country,
  GetNumbersFromRegionState,
  MsisdnRequestDto,
  PhoneNumber,
  PricingItem,
  PricingNumbers
} from '../../get-number/pricing-numbers/pricing-numbers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StateResponse } from '../../lead-generation/shared/domain/StateResponse';

@Injectable()
export class PricingNumbersService {
  constructor(private http: HttpClient) {}

  getAvailableCountries() {
    return this.http.get<Country[]>('/pricings/numbers/countries');
  }

  getPricingNumbersWithDocuments(countryCode: string) {
    return this.http.get<PricingNumbers>('/pricings/numbers/with-documents', {
      params: {
        code: countryCode
      }
    });
  }

  getSinglePricing(pricingId: number): Observable<PricingItem> {
    return this.http.get<PricingItem>(`/msisdns/pricing/${pricingId}`);
  }

  getPhoneNumbers(pricingId: number, searchText: string): Observable<PhoneNumber[]> {
    return this.http.get<PhoneNumber[]>('/pricings/numbers/available-numbers', {
      params: {
        pricingId: pricingId.toString(),
        searchText
      }
    });
  }

  getRandomNumberForCountry(code: string): Observable<MsisdnRequestDto | null> {
    return this.http.post<MsisdnRequestDto | null>(
      '/pricings/numbers/random',
      {},
      {
        params: {
          code
        }
      }
    );
  }

  availableNumbersState(pricingId: number): Observable<GetNumbersFromRegionState> {
    return this.http
      .get<StateResponse<GetNumbersFromRegionState>>('/pricings/numbers/available-numbers-state', {
        params: {
          pricingId: pricingId.toString()
        }
      })
      .pipe(map(response => response.state));
  }
}
